"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionSchema = exports.AMOUNT_UNPAID_REQUIRED = exports.DATE_OF_ISSUE_REQUIRED = exports.PRICE_PER_SHARE_REQUIRED = exports.SHARE_CLASS_REQUIRED = exports.TRANSACTION_TYPE_REQUIRED = exports.NUMBER_FIELD_MESSAGE = void 0;
const yup = __importStar(require("yup"));
const moment_1 = __importDefault(require("moment"));
const constants_1 = require("../constants");
exports.NUMBER_FIELD_MESSAGE = "Please enter a numeric value.";
exports.TRANSACTION_TYPE_REQUIRED = "Please select Transaction Type";
exports.SHARE_CLASS_REQUIRED = "Please select Share Class";
exports.PRICE_PER_SHARE_REQUIRED = "Please enter Price per share";
exports.DATE_OF_ISSUE_REQUIRED = "Please enter the date of issue";
exports.AMOUNT_UNPAID_REQUIRED = "Please enter the amount unpaid";
const TransactionSchema = yup.object().shape({
    transactionType: yup.string().trim().nullable(),
    shareClassId: yup.string().trim().required(exports.SHARE_CLASS_REQUIRED),
    quantity: yup
        .number()
        // eslint-disable-next-line no-restricted-globals
        .transform((value) => (isNaN(value) ? undefined : value))
        .required(constants_1.QUANTITY_REQUIRED)
        .integer()
        .positive(constants_1.QUANTITY_POSITIVE),
    pricePerShare: yup
        .number()
        // eslint-disable-next-line no-restricted-globals
        .transform((value) => (isNaN(value) ? undefined : value))
        .required(exports.PRICE_PER_SHARE_REQUIRED)
        .test("pricePerShare", "Price per share cannot be less than 0", (pricePerShare) => pricePerShare >= 0),
    dateOfTransaction: yup
        .string()
        .trim()
        .required(exports.DATE_OF_ISSUE_REQUIRED)
        .test("dateOfTransaction", "Please enter a valid date", (dateOfTransaction) => (0, moment_1.default)(dateOfTransaction).isValid())
        .test("dateOfTransaction", "Date of issue cannot be in future", (dateOfTransaction) => (0, moment_1.default)(dateOfTransaction).diff((0, moment_1.default)(), "days") <= 0),
    amountPaid: yup
        .number()
        // eslint-disable-next-line no-restricted-globals
        .transform((value) => (isNaN(value) ? undefined : value))
        .required(constants_1.AMOUNT_PAID_REQUIRED)
        .test("amountPaid", "Amount paid cannot be less than 0", (amountPaid) => amountPaid >= 0)
        .when(["quantity", "pricePerShare"], (quantity, pricePerShare, schema) => schema.test("amountPaid", "Total amount paid must be equal to the price per share x quantity of shares", (amountPaid) => {
        const total = Math.round(quantity * pricePerShare * 100) / 100;
        return amountPaid === total;
    })),
    amountUnpaid: yup
        .number()
        // eslint-disable-next-line no-restricted-globals
        .transform((value) => (isNaN(value) ? undefined : value))
        .required(exports.AMOUNT_UNPAID_REQUIRED)
        .test("amountUnpaid", "Amount unpaid cannot be less than 0", (amountUnpaid) => amountUnpaid >= 0)
        .when(["quantity", "pricePerShare", "amountPaid"], (quantity, pricePerShare, amountPaid, schema) => schema.test("amountUnpaid", "Total amount Unpaid must be equal to the difference of total value and amount paid", (amountUnpaid) => {
        const total = Math.round(quantity * pricePerShare * 100) / 100;
        return amountUnpaid === total - amountPaid;
    })),
});
exports.TransactionSchema = TransactionSchema;
//# sourceMappingURL=Transaction.js.map